import { Col, Container, Row } from 'react-bootstrap';
import { Container as StyledContainer } from '../../styles';
import PagePermissionsCard from './components/PagePermissionsCard';
import { OptionType, SelectedPermissionType } from '../../types';
import { PermissionsContainer } from './styles';

interface IPermissionsCard {
  permissionsOptions: OptionType[];
  selectedPermissions: SelectedPermissionType[];
  handleOpenPageBeingSettedPermissionsModal: (page: OptionType) => void;
}

export default function PermissionsCard({
  permissionsOptions,
  selectedPermissions,
  handleOpenPageBeingSettedPermissionsModal,
}: IPermissionsCard) {
  const userPermissions = permissionsOptions?.map((permission) => {
    const currentPermissionsOfUserAtPage = selectedPermissions?.find((page) => page.pageCode === permission.pageCode) ?? {
      pageCode: permission.pageCode,
      pageLabel: permission.pageLabel,
      add: false,
      view: false,
      update: false,
      download: false,
      delete: false,
    };

    return currentPermissionsOfUserAtPage;
  });
  return (
    <StyledContainer>
      <div className="card-title">
        Permissões
      </div>
      <PermissionsContainer>
        <Container>
          <Row xs={1} md={1} lg={2}>
            {userPermissions.map((permission) => (
              <Col key={permission.pageCode}>
                <PagePermissionsCard
                  pageLabel={permission.pageLabel}
                  pageCode={permission.pageCode}
                  permissions={permission}
                  handleOpenPageBeingSettedPermissionsModal={handleOpenPageBeingSettedPermissionsModal}
                />
              </Col>
            ))}
            <Col>

            </Col>
          </Row>
        </Container>
      </PermissionsContainer>
    </StyledContainer>
  );
}
